import { SFormList } from 'shj-components'
import { useEffect } from 'react'
import { Form, Input, message } from 'antd'
import { addSpaceSpecificationArg, spaceSpecificationArgUpdateById } from '@/services/product.ts'
import { isEmpty } from 'lodash-es'
import { trimStr } from '@/utils/data.ts'

const AddOrEditConfigure = props => {
  const { editRef } = props
  const [form] = Form.useForm()

  useEffect(() => {
    form.resetFields()
    if (!isEmpty(props.record)) {
      const obj = { ...props.record }
      obj.values = props.record.values
      form.setFieldsValue(obj)
    }
  }, [props.record])

  const onFinish = () => {
    form.validateFields().then(formValues => {
      props.setLoading?.(true)
      formValues.values = formValues.values || undefined
      const apiUrl = formValues.id ? spaceSpecificationArgUpdateById : addSpaceSpecificationArg
      apiUrl({ data: { ...formValues } })
        .then((res: any) => {
          message.success(res.message || '操作成功')
          props.onCancel?.()
          props.fn?.()
        })
        .finally(() => props.setLoading?.(false))
    })
  }

  if (editRef) editRef.onFinish = onFinish

  const onRemove = (remove, filed) => {
    let value = form.getFieldValue(['values', filed.name])
    if (!value?.id) {
      const list = form.getFieldValue(['values']) || [];
      list.splice(filed.name, 1);
      form.setFieldValue(['values'], list);
    } else {
      message.warning('已保存数据不能删除')
    }
  }
  return (
    <>
      <Form
        style={{ maxHeight: 500, overflowY: 'auto' }}
        form={form}
        layout={'vertical'}
        initialValues={{ values: [{ argValue: '' }] }}
      >
        <Form.Item label={'id'} name={'id'} hidden>
          <Input />
        </Form.Item>
        <Form.Item label={'argCode'} name={'argCode'} hidden>
          <Input />
        </Form.Item>
        <Form.Item
          label={'参数名称'}
          name={'argName'}
          required={true}
          rules={[{ required: true, message: '参数名称不能为空' }]}
        >
          <Input
            placeholder={'请输入参数名称'}
            maxLength={15}
            showCount
            onChange={e => {
              form.setFieldValue('argName', trimStr(e.target.value))
            }}
          />
        </Form.Item>
        <Form.Item label={'参数可选项'} required={true}>
          <SFormList
            onRemove={onRemove}
            name={'values'}
            addType={['icon']}
            leastOne={true}
            showMode={{ add: true }}
          >
            <Form.Item name={'id'} hidden>
              <Input />
            </Form.Item>
            <Form.Item
              name={'argValue'}
              style={{ flex: 1 }}
              rules={[{ required: true, message: '参数不能为空' }]}
            >
              <Input placeholder={'请输入参数可选项'} maxLength={50} showCount />
            </Form.Item>
          </SFormList>
        </Form.Item>
      </Form>
    </>
  )
}

export default AddOrEditConfigure
